// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import type { PreviewData } from './NamedPreview'
import { translateFunc, translations } from '../../shared/localize'
import NamedPreview from './NamedPreview'
import { defaultVkLinkButton, defaultTmLinkButton, defaultFbLinkButton } from '../constants'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  & > div {
    display: inline-block;
    vertical-align: top;
  }
`
const Container: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-right: 9px;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  margin: 0 20px 10px 0;
  text-align: center;
`
const Item: StyledComponent<Object, any, any> = styled.div`
  background: #f2f2f2;
  padding: 25px 15px;
  display: inline-block;
  margin: 0 25px 25px 0;
`

const t = {
  tm_banner: 'myTarget - баннер',
  vk_preview: 'ВКонтакте',
  multi_facebook_preview: 'Facebook - пост в ленте',
  instagram_preview: 'Instagram - пост в ленте',
  facebook_mobile: 'Facebook - Audience Network - Фулскрин',
  facebook_string: 'Facebook - растяжка',
  facebook_preview: 'Facebook - в колонке',
  tm_lenta: 'myTarget - пост в ленте',
  tm_line: 'myTarget - строчка',
  google_preview: 'Google - баннер',
  google_simple: 'Google - баннер',
  tm_preview: 'myTarget',
  tm_preview_multi: 'myTarget - тизер',
  vk_promopost: 'Вконтакте - пост в ленте'
}

type Props = {|
  names: Array<string>,
  data: PreviewData
|}

export default function ProviderPreviews(props: Props) {
  const titleTr = translateFunc(t)

  return (
    <Wrapper>
      {props.names.map((name, index) => {
        return (
          <Container key={index}>
            <Title>{titleTr(name)}</Title>
            <Item>
              <NamedPreview name={name} data={fillEmptyFieldsWithDefaultValues(props.data)} />
            </Item>
          </Container>
        )
      })}
    </Wrapper>
  )
}

function fillEmptyFieldsWithDefaultValues(data: PreviewData): PreviewData {
  const adEditTr = translateFunc(translations.ad_edit)

  return {
    ...data,
    url: data.url || adEditTr('domain'),
    title: data.title || adEditTr('title'),
    vkTitle: data.vkTitle || data.title || adEditTr('title'),
    fbTitle: data.fbTitle || data.title || adEditTr('title'),
    description: data.description || adEditTr('description'),
    vkExtendedDescription:
      data.vkExtendedDescription || data.description || adEditTr('description'),
    fbExtendedDescription:
      data.fbExtendedDescription || data.description || adEditTr('description'),
    vkLinkButton: data.vkLinkButton || defaultVkLinkButton,
    tmLinkButton: data.tmLinkButton || defaultTmLinkButton,
    fbLinkButton: data.fbLinkButton || defaultFbLinkButton
  }
}
